export const enum PoolingRoutes {
  BookingIRI = `/material_bookings/:id`,
  IRI = `/materials/:slug`,
  Search = `/pooling`,
  Show = '/pooling/:slug',
  New = '/pooling/new',
  MyMaterials = '/my/materials',
  AddFromTemplates = '/my/materials/add-from-templates',
  EditMyMaterial = '/pooling/:slug/edit',
  EditMyMaterialStep = '/pooling/:slug/edit/:step',
  Calendar = '/my/materials/:slug/calendar',
  MaterialMaintenanceLogBook = '/my/materials/:slug/log-book',
  MyBookingRequests = '/my/bookings/requests',
  MyBookingAsOwner = '/my/bookings/as-owner',
  MyBookingShow = '/my/bookings/:id',
  MyAlerts = '/my/alerts',
}

export const enum StaticPagesRoutes {
  Home = '/',
  Contact = '/contact',
  Team = '/team',
  Contribute = '/contribute',
  Donate = '/donate',
  Privacy = '/privacy',
  Terms = '/terms',
  Library = '/library',
  LibraryAIPage = '/library/ai',
  LibraryAuthPage = '/library/auth',
  LibraryChartsPage = '/library/charts',
  LibraryDividersPage = '/library/dividers',
  LibraryFeedsPage = '/library/feeds',
  LibraryHeadersPage = '/library/headers',
  LibraryOnboardingPage = '/library/onboarding',
  LibraryProfilesPage = '/library/profiles',
  LibraryPropertyPanelsPage = '/library/property-panels',
  LibrarySettingsPage = '/library/settings',
  LibrarySharingPage = '/library/sharing',
  LibraryFeaturePage = '/library/feature',
  LibrarySidebarsPage = '/library/sidebars',
  LibraryHelpCenterPage = '/library/help-center',
  LibraryNavBarsPage = '/library/navbars',
}

export const enum AdminRoutes {
  Home = '/admin',
  Users = '/admin/users',
  UserEdit = '/admin/users/:slug/edit',
  Tech = '/admin/tech',
  Networks = '/admin/networks',
  NetworkDetail = '/admin/networks/:slug',
  NetworkEdit = '/admin/networks/:slug/edit',
  Communities = '/admin/communities',
  CommunityDetail = '/admin/communities/:slug',
  CommunityEdit = '/admin/communities/:slug/edit',
  Materials = '/admin/materials',
  Categories = '/admin/categories',
  MaterialEdit = '/admin/materials/:slug/edit',
  MaterialDetail = '/admin/materials/:slug',
  MaterialBookings = '/admin/materials/bookings',
  Plans = '/admin/plans',
  PlanEdit = '/admin/plans/:id/edit',
  NetworkSubscriptions = '/admin/subscriptions',
  NetworkSubscriptionDetail = '/admin/subscriptions/:id',
  Announcements = '/admin/announcements',
}

export const enum CommunitiesRoutes {
  IRI = `/circles/:slug`,
  InvitationLinksIRI = `/circle_invitation_links/:token`,
  Map = `/map`,
  Show = '/communities/:slug',
  New = '/my/communities/new',
  Edit = '/c/:slug/settings',
  Dashboard = '/c/:slug',
  EditStep = '/c/:slug/settings/:step',
  SettingsMedia = '/c/:slug/settings/media',
  SettingsInsurance = '/c/:slug/settings/insurance',
  SettingsBookingDocuments = '/c/:slug/settings/booking-documents',
  Members = '/c/:slug/members',
  Networks = '/c/:slug/networks',
  Materials = '/c/:slug/materials',
  MaterialCalendar = '/c/:slug/materials/:materialSlug/calendar',
  MaterialMaintenanceLogBook = '/c/:slug/materials/:materialSlug/log-book',
  AddFromTemplates = '/c/:slug/materials/add-from-templates',
  BookingRequests = '/c/:slug/bookings/requests',
  BookingAsOwner = '/c/:slug/bookings/as-owner',
  BookingShow = '/c/:slug/bookings/:uuid',
  MaterialEdit = '/c/:communitySlug/materials/:materialSlug/edit',
  MaterialEditStep = '/c/:communitySlug/materials/:materialSlug/edit/:step',
  MyCommunities = '/my/communities',
  Discover = '/communities/discover',
}

export const enum NetworksRoutes {
  IRI = `/networks/:slug`,
  MyNetworks = '/my/networks',
  New = '/networks/new',
  MyShow = IRI,
  Members = '/n/:slug/members/:communitySlug?',
  Dashboard = '/n/:slug',
  Edit = '/n/:slug/settings',
  Communities = '/n/:slug/communities',
  SettingsSso = '/n/:slug/settings/sso',
  SettingsSubscription = '/n/:slug/settings/subscription',
  SettingsWhiteLabel = '/n/:slug/settings/white-label',
  SettingsWebhooks = '/n/:slug/settings/webhooks',
  SettingsWebhookNew = '/n/:slug/settings/webhooks/new',
  SettingsWebhookDetail = '/n/:slug/settings/webhooks/:endpointId',
  SettingsWebhookDelivery = '/n/:slug/settings/webhooks/:endpointId/log/:deliveryId',
  Materials = '/n/:slug/materials',
  MaterialCalendar = '/n/:slug/materials/:materialSlug/calendar',
  MaterialMaintenanceLogBook = '/n/:slug/materials/:materialSlug/log-book',
  AddFromTemplates = '/n/:slug/materials/add-from-templates',
  BookingRequests = '/n/:slug/bookings/requests',
  BookingAsOwner = '/n/:slug/bookings/as-owner',
  BookingShow = '/n/:slug/bookings/:uuid',
  MaterialEdit = '/n/:networkSlug/materials/:materialSlug/edit',
  MaterialEditStep = '/n/:networkSlug/materials/:materialSlug/edit/:step',
}

export const enum UserRoutes {
  IRI = `/users/:slug`,
  InvitationsIRI = `/invitations/:id`,
  Register = '/register',
  RequestInvite = '/request-invite',
  Login = '/login',
  NetworkSsoLogin = '/login/:networkSlug',
  AuthCallback = '/auth/callback',
  Logout = '/logout',
  ForgotPassword = '/forgot-password',
  ForgotPasswordReset = '/forgot-password/:token',
  MyProfile = '/my/profile',
  MyPreferences = '/my/preferences',
  MyNotifications = '/notifications',
  MyLists = '/my/lists',
  EditMyList = '/my/lists/:slug',
  Profile = '/user/:slug',
  FAQ = '/faq',
}

export const enum APIRoutes {
  IRI = '/:ns/:id',
}

export const enum RedirectRoutes {
  Redirect = '/redirect',
}
